import $ from 'jquery';
import PerformantEvents from './performant-events';

var $magnetNav;
var $body;
var $anchors;
var $modalHeaderActiveAnchor;
var $magnetNavLinks;
var $magnetNavContainer;
var $magnetNavOverflow;
var $hideables;

var $activeAnchor = false;
var stickyState = true;
var lastActiveHref = false;
var hashDebounce = false;
var siteHeaderHeight;
var bodyOffsetTop;

export default function init() {
    $magnetNav = $('.js-magnet-navigation');

    if ($magnetNav.length <= 0) {
        return false;
    }
    $body = $("body");
    bodyOffsetTop = $body.offset().top;
    $magnetNavLinks = $('.js-magnet-navigation__link');
    $magnetNavOverflow = $('.js-magnet-navigation-overflow');
    $modalHeaderActiveAnchor = $('.js-magnet-navigation__modal-header__link-active');
    // $anchors = $(".js-magnet__anchor");
    $anchors = $('[data-magnet-navigation="true"]')
    $magnetNavContainer = $('.js-magnet-navigation__container');
    $hideables = $('.js-site-header, .js-main-navigation-wrapper, .js-main-footer, .js-magnet-navigation__open-modal, .component:not(.js-magnet-navigation__container)');

    $magnetNavLinks.on('click', navigateToAnchor);

    PerformantEvents.onEvent('resize', hideOrUnstickyMagnetNavigation);
    PerformantEvents.onEvent('resize', checkNavigationLengthForModal);
    PerformantEvents.onEvent('scroll', checkScrollDistanceForStickying);
    PerformantEvents.onEvent('scroll', checkActiveMagnetNavItem);

    var $toggle = $('.js-magnet-navigation__open-modal');
    var $modal = $('.js-magnet-navigation-modal');
    var $modalContent = $('.js-magnet-navigation-modal-content');

    $modalContent.on('click', function(e) {
        e.stopPropagation();
    });

    $modalContent.on('click', '.js-magnet-navigation__link, .js-close-modal', function() {
        $modal.trigger('click');
    });

    $modal.on('click', function() {
        closeModal($toggle, $modal);
    });

    $toggle.on('click', function() {
        $toggle.attr('aria-expanded', 'true');
        $modal.fadeIn('fast', function() {
            disableScrolling($body);
            $(this).focus();
        });
        $hideables.attr('aria-hidden', true);

        $(document).on('keyup.closeModal', function(e) {
            if (e.keyCode === 27) { // esc
                closeModal($toggle, $modal);
            }
        });
    });

    $( document ).ready(function() {
        checkNavigationLengthForModal();
    });
}

function closeModal($toggle, $modal) {
    $hideables.attr('aria-hidden', false);
    $modal.fadeOut(200);
    $toggle.attr('aria-expanded', 'false').delay(200).focus();
    enableScrolling($body);
}

function navigateToAnchor(e) {
    e.preventDefault(); // Stops the page from jumping
    enableScrolling($body);
    var href = $(e.target).attr('href');
    var $anchor = $(href);
    var scrollTop = $anchor.offset().top - 180;

    $('html, body').stop(true, false).animate({scrollTop: scrollTop}, 250, "swing", hideOrUnstickyMagnetNavigation);

    // Accessibility focus on click
    // https://css-tricks.com/smooth-scrolling-accessibility/
    $anchor.focus();
    if ($anchor.is(":focus")) {
      return !1;
    } else {
      $anchor.attr('tabindex', '-1');
      $anchor.focus();
    }
}

function hideOrUnstickyMagnetNavigation() {
    checkScrollDistanceForStickying(window.pageYOffset, "down");
}

function checkScrollDistanceForStickying(position, scrollDirection) {
    var magnetNavContainerPositionTop = $magnetNavContainer.offset().top - 1;
    var magnetNavContainerPositionBottom = magnetNavContainerPositionTop + $magnetNavContainer.height();
    siteHeaderHeight = $('.js-site-header').height();

    if (position >= magnetNavContainerPositionBottom && scrollDirection === "down" && stickyState !== "hidden") {
        hideMagnetNavigation();
    } else if ((position + bodyOffsetTop) < magnetNavContainerPositionTop && stickyState !== "unsticky") {
        unStickyMagnetNavigation();
    } else if (position >= magnetNavContainerPositionBottom && scrollDirection === "up" && stickyState !== "visible") {
        showMagnetNavigation();
    }
}

function hideMagnetNavigation() {
    if(!$magnetNavContainer.hasClass('active')) {
        $magnetNav.css({top: -200});
    }

    $magnetNavContainer.removeClass('active');
    $magnetNav.css({position: "fixed"});
    $magnetNav.css({transform: "translateY(-135%)"});
    stickyState = "hidden";
}

function unStickyMagnetNavigation() {
    if($magnetNavContainer.hasClass('active')) {
        $magnetNav.css({top: bodyOffsetTop * -1});
    }

    $magnetNavContainer.removeClass('active');
    $magnetNav.css({position: "relative"});
    stickyState = "unsticky";
}

function showMagnetNavigation() {
    $magnetNavContainer.addClass('active');
    $magnetNav.css({ top: siteHeaderHeight });
    $magnetNav.css({position: "fixed"});
    $magnetNav.css({transform: "translateY(" + bodyOffsetTop + "px)"});
    stickyState = "visible";
}

function checkActiveMagnetNavItem(position) {
    var center = ($(window).height() / 2);
    var currentCenter = position + center;

    var $anchorsAboveCenter = $anchors.filter(function (k, anchor) {
        return currentCenter > $(anchor).offset().top;
    });

    if ($anchorsAboveCenter.length === 0) {
        $activeAnchor = $anchors.first();
    } else {
        $activeAnchor = $anchorsAboveCenter.last();
    }

    var href = "#" + $activeAnchor.attr("id");

    if( parseInt($(window).scrollTop() ) === 0 ) {
        href = "";
    }

    if (lastActiveHref === href) {
        return;
    }
    lastActiveHref = href;

    var $activeMagnetNavLink = $magnetNavLinks.filter('[href="' + href + '"]');

    $magnetNavLinks.removeClass('active');
    $activeMagnetNavLink.addClass('active');

    $modalHeaderActiveAnchor.attr('href', href);
    $modalHeaderActiveAnchor.text($activeMagnetNavLink.first().text());

    updateHashWithDebounce(href, 500);
}

function updateHashWithDebounce(href, debounceTime) {
    clearTimeout(hashDebounce);
    if(href === "") {
        history.replaceState("", document.title, window.location.pathname);
    } else {
        hashDebounce = setTimeout(function () {
            if (history.replaceState) {
                history.replaceState(null, null, href);
            }
        }, debounceTime);
    }
}

function checkNavigationLengthForModal() {
    var EXTRA_PADDING_BEFORE_MODAL = 50;
    var scrollWidth = $magnetNavOverflow.prop('scrollWidth') + EXTRA_PADDING_BEFORE_MODAL;
    var magnetWidth = $magnetNav.width();

    if (scrollWidth > magnetWidth && !$magnetNavContainer.hasClass('modal')) {
        $magnetNavContainer.addClass('modal');
    } else if (scrollWidth < magnetWidth && $magnetNavContainer.hasClass('modal')) {
        $magnetNavContainer.removeClass('modal');
    }
}

function disableScrolling(target) {
    $(target).addClass('stop-scrolling');
}

function enableScrolling(target) {
    $(target).removeClass('stop-scrolling');
}
